import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  ActionDTO,
  ConditionDTO,
  TriggerDTO,
} from '@/../client-generator/generated-clients/plants';

import SceneListItem from './SceneListItem/SceneListItem.vue';

@Options({
  name: 'SceneStepItemsList',
  props: {
    items: {
      type: Array as PropType<ActionDTO[] | TriggerDTO[] | ConditionDTO[]>,
    },
  },
  emits: ['remove', 'edit'],
  components: { SceneListItem },
})
export default class SceneStepItemsList extends Vue {
  handleAction(
    actionName: string,
    item: ActionDTO | TriggerDTO | ConditionDTO
  ) {
    this.$emit(actionName, item);
  }
}
